// extracted by mini-css-extract-plugin
export default {"customContactInput":"ContactNumberInput_customContactInput__JG9gi"};